import { FormControlError, FormControlErrorText } from "@gluestack-ui/themed";
import { ISelectError } from "./types";

export const SelectError = ({ errorMessage }: ISelectError) => {
  if (!errorMessage) return null;

  return (
    <FormControlError>
      <FormControlErrorText>{errorMessage}</FormControlErrorText>
    </FormControlError>
  );
};
